import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {omit} from "../../../__snowpack__/pkg/lodash.js";
import {useState} from "../../../__snowpack__/pkg/react.js";
export const useBrands = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/product-brand/channels/get-brands-by-channel`, {
        params: omit(params, "appendBrands")
      });
      let newData = data2;
      if (!params.prefix) {
        newData = [
          {
            label: "0",
            value: "NoBrand"
          },
          ...data2.filter((uData) => {
            return uData.label != "0";
          })
        ];
      }
      setData([...params.appendBrands || [], ...newData].reduce((acc, cur) => {
        if (!acc.find((_) => _.label === cur.label)) {
          acc.push(cur);
        }
        return acc;
      }, []));
      return newData;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    brandsLoading: loading,
    brands: data,
    fetchBrands: fetchData,
    setBrands: setData
  };
};
export const useBrandsModel = createModel(useBrands);
